import { render, staticRenderFns } from "./BatchResourceUpload.vue?vue&type=template&id=496088dc&scoped=true"
import script from "./BatchResourceUpload.vue?vue&type=script&lang=js"
export * from "./BatchResourceUpload.vue?vue&type=script&lang=js"
import style0 from "./BatchResourceUpload.vue?vue&type=style&index=0&id=496088dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496088dc",
  null
  
)

export default component.exports